module.exports = __webpack_public_path__ + "media/assets/icons/facebook-621344f4c072f5b7687a85ada40bcdfe.svg";